import React, { useState } from 'react';
import ScrollPicker from '../ScrollPicker';

const MONTHS = [
  'Janvier','Février','Mars','Avril','Mai','Juin',
  'Juillet','Août','Septembre','Octobre','Novembre','Décembre',
];

function buildDays() {
  return Array.from({ length: 31 }, (_, i) => ({ value: i + 1, label: String(i + 1) }));
}
function buildMonths() {
  return MONTHS.map((m, i) => ({ value: i + 1, label: m }));
}
function buildYears() {
  const now = new Date().getFullYear();
  return Array.from({ length: 100 }, (_, i) => {
    const y = now - i;
    return { value: y, label: String(y) };
  });
}

const DAYS   = buildDays();
const MONTHS_LIST = buildMonths();
const YEARS  = buildYears();

function calcAge(day, month, year) {
  const today = new Date();
  const birth = new Date(year, month - 1, day);
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age;
}

export default function Step2Birthday({ data, onNext, onBack, onLoginRedirect }) {
  const [day,   setDay]   = useState(data.birthday?.day   || 1);
  const [month, setMonth] = useState(data.birthday?.month || 1);
  const [year,  setYear]  = useState(data.birthday?.year  || (new Date().getFullYear() - 20));
  const [error, setError] = useState('');

  const handleNext = () => {
    const age = calcAge(day, month, year);
    if (age < 18) {
      setError('Vous devez avoir au moins 18 ans.');
      return;
    }
    onNext({ birthday: { day, month, year } });
  };

  return (
    <div style={styles.page}>
      <div style={styles.topBar}>
        <button style={styles.back} onClick={onBack}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span style={styles.stepLabel}>Create Account (2/4)</span>
        <div style={{ width: 36 }} />
      </div>

      <div style={styles.content}>
        <h2 style={styles.title}>Date de naissance</h2>
        <p style={styles.sub}>Âge minimum 18 ans</p>

        <div style={styles.pickerRow}>
          <ScrollPicker items={DAYS}         value={day}   onChange={setDay}   />
          <ScrollPicker items={MONTHS_LIST}  value={month} onChange={setMonth} />
          <ScrollPicker items={YEARS}        value={year}  onChange={setYear}  />
        </div>

        {error && <p style={styles.error}>{error}</p>}
      </div>

      <div style={styles.bottom}>
        <button style={styles.btnNext} onClick={handleNext}>
          Next
        </button>
        <button style={styles.loginLink} onClick={onLoginRedirect}>
          I already have an account
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f5f7ff', display: 'flex', flexDirection: 'column', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
  topBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px' },
  back: { background: 'none', border: 'none', cursor: 'pointer', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  stepLabel: { color: '#333', fontSize: 15, fontWeight: 600 },
  content: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 24px 20px' },
  title: { fontSize: 26, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 },
  sub: { fontSize: 14, color: '#888', marginBottom: 32, textAlign: 'center' },
  pickerRow: { display: 'flex', gap: 8, width: '100%', maxWidth: 380, background: '#fff', borderRadius: 16, padding: '8px 0', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' },
  error: { color: '#e74c3c', fontSize: 13, marginTop: 16 },
  bottom: { padding: '0 24px 40px', display: 'flex', flexDirection: 'column', gap: 14, alignItems: 'center' },
  btnNext: { background: '#3d5ef5', color: '#fff', border: 'none', borderRadius: 14, height: 54, fontSize: 16, fontWeight: 600, cursor: 'pointer', width: '100%', maxWidth: 480 },
  loginLink: { background: 'none', border: 'none', color: '#3d5ef5', fontSize: 14, fontWeight: 500, cursor: 'pointer' },
};
